/* eslint-disable import/prefer-default-export */

import { gql } from "@apollo/client";

export const STUDENT_LOGIN = gql`
  mutation StudentLogin($userInput: AuthCredetials!) {
    StudentLogin(userInput: $userInput)
  }
`;
